import { defineStore } from 'pinia';
import { ref } from 'vue';
import type { SiteStatus } from '~/handlers/ports/api-fetch-site-status.port';
import { fetchSiteStatusHandler } from '~/handlers/fetch-site-status.handler';

// Fallback de código: o mesmo site pausado da Medida Provisória (ENG-899). Vale
// só enquanto o core nunca respondeu neste navegador — se ele cair, o site não
// reabre sozinho.
const PAUSED_FALLBACK: SiteStatus = {
  homeNoticeEnabled: true,
  gamesEnabled: false,
  depositsEnabled: false,
  registrationsEnabled: false,
  dailyCheckInEnabled: false,
  rouletteEnabled: false,
  notices: {},
};

// Revalida com o site aberto, pra que religar algo no core chegue sem F5.
const POLL_INTERVAL_MS = 60 * 1000;

// Operações do site (ENG-915): o que o core liga e desliga em Administrativo ›
// Operações do site, lido de GET /api/site-status. Persistido: a última resposta
// boa é o fallback da próxima visita quando o core não responder.
export const useSiteStatusStore = defineStore(
  'ap.site-status',
  () => {
    const status = ref<SiteStatus>({ ...PAUSED_FALLBACK });

    let pollingStarted = false;

    async function refresh() {
      const fresh = await fetchSiteStatusHandler();

      if (fresh) {
        status.value = fresh;
      }
    }

    function startPolling() {
      if (pollingStarted || !import.meta.client) return;

      pollingStarted = true;

      setInterval(() => {
        if (document.visibilityState === 'visible') refresh();
      }, POLL_INTERVAL_MS);

      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') refresh();
      });
    }

    return {
      status,
      refresh,
      startPolling,
    };
  },
  {
    persist: {
      storage: piniaPluginPersistedstate.localStorage(),
      pick: ['status'],
    },
  },
);
